"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.documentReducer = void 0;
var typesafe_actions_1 = require("typesafe-actions");
var DocumentAction_1 = require("@/pages/document/actions/DocumentAction");
exports.documentReducer = function (defaultState) {
    return function (state, action) {
        if (state === void 0) { state = defaultState; }
        switch (action.type) {
            case typesafe_actions_1.getType(DocumentAction_1.default.onMoreClicked): {
                var index_1 = action.payload;
                return __assign(__assign({}, state), { eforms: state.eforms.map(function (it, i) {
                        var _a;
                        if (i === index_1)
                            return __assign(__assign({}, it), { isExpanded: !((_a = it.isExpanded) !== null && _a !== void 0 ? _a : false) });
                        return it;
                    }) });
            }
            case typesafe_actions_1.getType(DocumentAction_1.default.setResult): {
                var _a = action.payload, eforms = _a.eforms, currentPage = _a.currentPage, totalPage = _a.totalPage, totalItems = _a.totalItems;
                return __assign(__assign({}, state), { totalPage: totalPage,
                    currentPage: currentPage,
                    totalItems: totalItems,
                    eforms: eforms, isLoading: false });
            }
            case typesafe_actions_1.getType(DocumentAction_1.default.setSortActive): {
                return __assign(__assign({}, state), { isSortActive: action.payload });
            }
            case typesafe_actions_1.getType(DocumentAction_1.default.onSortLabelClick): {
                return __assign(__assign({}, state), { isSortActive: !state.isSortActive });
            }
            case typesafe_actions_1.getType(DocumentAction_1.default.onSortChanged): {
                return __assign(__assign({}, state), { isSortActive: false });
            }
            default:
                return state;
        }
    };
};
